





export default [
  {
    id: 'scene1',
    urls: [
      require('@/assets/img/scenes/scene1/item_icons/item_001.png'),
    ],
  },
]
